import React from 'react';
import { IconProps } from './model/IconInterface';

const PalletStackIcon: React.FC<IconProps> = ({ size = 20, color = 'currentColor' }) => (
    <svg
        width={size}
        height={size}
        viewBox='0 0 24 24'
        fill='none'
        stroke={color}
        strokeWidth={1.8}
        strokeLinecap='round'
        strokeLinejoin='round'
        aria-hidden
    >
        <polygon points='12 3 21 8 12 13 3 8' />
        <polyline points='3 14 12 19 21 14' />
        <polyline points='3 11 12 16 21 11' />
    </svg>
);

export default PalletStackIcon;
